import React, { useState } from 'react'
import { BsArrowRightShort } from 'react-icons/bs'
import EnterNumberModal from '../EnterNumberModal/EnterNumberModal'
import AuthenticatorModal from '../AuthenticatorModal/AuthenticatorModal'
import AddSecurityKeyModal from '../AddSecurityKeyModal/AddSecurityKeyModal'
import { HiCheckCircle } from 'react-icons/hi2'

const SecureAccount = ({ setStep, setMainStep, SetSecureAccount, isUpdate, setData }) => {
    const [active, setActive] = useState(false)
    const [auth, setAuth] = useState(false)
    const [addKey, setAddKey] = useState(false)

    const handleContinue = () => {
        if(isUpdate){
            setMainStep('step5');
            setStep('Summary');
            setData('default')
        } else {
            setMainStep('step4')
            setStep('taxCalc')
        }
    }

    return (
        <>
            <div>
                <div>
                    <h3 className='text-[#30313d] sm:text-[32px] text-[24px] font-semibold leading-[36px]'>Keep your account secure</h3>
                    <p className='text-[#414552] mt-2'>Stripe requires two-step authentication in order to keep your account secure. By using either your phone or an authenticator app in addition to your password, you ensure that no one else can log in to your account.</p>
                    <p className='text-[#414552] mt-2'>We encourage you to enable multiple forms of two-step authentication as a backup in case you lose your mobile device or lose service.</p>
                </div>
                <div className='flex items-center gap-2 text-sm font-semibold text-[#414552] p-[12px] rounded-[6px] mt-3 border-[1px] border-[#ebeef1]'>
                    <HiCheckCircle className='text-[#3fa40d] text-[20px]' />SMS
                </div>
                <div className='mt-3'>
                    <button onClick={() => {setAuth(true); SetSecureAccount({account_secure_method: 'Authenticator app'})}} className="input_focus_shadow rounded-md flex items-center font-medium w-full gap-2 h-[36px] pl-2 pr-3 py-2 justify-center text-[#404552]">Use an authenticator app</button>
                    <button onClick={() => {setAddKey(true); SetSecureAccount({account_secure_method: 'Security key'})}} className="input_focus_shadow rounded-md mt-2 flex items-center font-medium w-full gap-2 h-[36px] pl-2 pr-3 py-2 justify-center text-[#404552]">Add a security key</button>
                    <button onClick={() => {setActive(true); SetSecureAccount({account_secure_method: 'SMS'})}} className="input_focus_shadow rounded-md mt-2 flex items-center font-medium w-full gap-2 h-[36px] pl-2 pr-3 py-2 justify-center text-[#404552]">Use SMS</button>
                </div>
                <div className='sm:mt-8 mt-5 pb-5'>
                    <button onClick={handleContinue} className='rounded-md flex items-center gap-1 font-semibold w-full h-[36px] px-4 py-2 justify-center text-white bg-[#625afa]'>Continue<BsArrowRightShort className='text-[25px]' /></button>
                </div>
            </div>
            <AuthenticatorModal auth={auth} setAuth={setAuth} />
            <AddSecurityKeyModal addKey={addKey} setAddKey={setAddKey} />
            <EnterNumberModal active={active} setActive={setActive} />
        </>
    )
}

export default SecureAccount